"use strict";

var PureRenderMixin = React.addons.PureRenderMixin;
var dealsAPI = require("app/util/api/deals");
var lossReasonsAPI = require("app/util/api/loss-reasons");
var DealLostPopbox = require("app/shared/components/DealLostPopbox/deal-lost-popbox");
var SignalActions = require("app/shared/actions/signal-actions");
var DatePicker = require("app/shared/components/DatePicker/date-picker");
var _ = require("underscore");
var moment = require("moment");
var DESCRIPTION_LENGTH_LIMIT = 255;
var DEAL_STATUS_LOST_ID = 3;

var DealLostPopboxContainer = React.createClass({
  mixins: [PureRenderMixin],
  propTypes: {
    dealId: React.PropTypes.number.isRequired,
    afterSaveCallback: React.PropTypes.func.isRequired,
    anchor: React.PropTypes.object,
    isVisible: React.PropTypes.bool,
    onClose: React.PropTypes.func
  },
  getDefaultProps: function() {
    return { isVisible: true };
  },
  getInitialState: function() {
    return {
      isPopboxVisible: this.props.isVisible,
      lossReasons: null,
      selectedLossReasonId: null,
      selectedDate: moment(new Date()).format(DatePicker.sysDateFormat),
      lossReasonDescription: null
    };
  },
  componentDidMount: function() {
    this.fetchLossReasons();
    this.fetchDeal();
  },
  componentWillReceiveProps: function(nextProps) {
    this.setState({ isPopboxVisible: nextProps.isVisible });
  },
  fetchLossReasons: function() {
    lossReasonsAPI.get(this.setLossReasonsToState, this.handleRequestError);
  },
  fetchDeal: function() {
    dealsAPI.get(null, this.props.dealId, this.initializeDeal, this.handleRequestError);
  },
  setLossReasonsToState: function(lossReasons) {
    this.setState({ lossReasons: lossReasons });
  },
  initializeDeal: function(deal) {
    var lossReasonId = null;
    var dealLossReasonId = null;
    var lossReasonDescription = null;
    var selectedMoment;

    if (deal.deal_loss_reason) {
      lossReasonId = deal.deal_loss_reason.loss_reason.id;
      dealLossReasonId = deal.deal_loss_reason.id;
      lossReasonDescription = deal.deal_loss_reason.description;
    }

    // If the deal is not lost yet, use the current date instead of the existing estimate.
    if (deal.deal_status.id === DEAL_STATUS_LOST_ID) {
      selectedMoment = moment(deal.ends_at);
    } else {
      selectedMoment = moment();
    }

    this.setState({
      selectedLossReasonId: lossReasonId,
      selectedDate: selectedMoment.format(DatePicker.sysDateFormat),
      dealLossReasonId: dealLossReasonId,
      lossReasonDescription: lossReasonDescription
    });
  },
  handleRequestError: function(error) {
    var message = "Ocorreu um erro inesperado, se persistir entre em contato com o nosso suporte.";

    if (error) {
      if (error.customError) {
        message = error.message + ", tente novamente mais tarde.";
      } else if (error.status === 403) {
        message = "Você não possui privilégio para finalizar um negócio. Contate o administrador de sua conta para lhe conceder este privilégio em <a href='/sistema/grupos'>Grupos</a>.";
      }
    }

    this.showSignal(message, "warning");
  },
  showSignal: function(message, type) {
    SignalActions.show({
      message: message,
      type: type,
      hideTimeout: 5000
    });
  },
  handleSelectLossReason: function(lossReason) {
    var selectedLossReasonId;
    var previousSelectionId = this.state.selectedLossReasonId;

    if (previousSelectionId === lossReason.id) {
      selectedLossReasonId = null;
    } else {
      selectedLossReasonId = lossReason.id;
    }

    var lossReasonDescription = this.state.lossReasonDescription;
    if (!selectedLossReasonId) {
      lossReasonDescription = null;
    }

    this.setState({
      selectedLossReasonId: selectedLossReasonId,
      lossReasonDescription: lossReasonDescription
    });
  },
  handleDateChange: function(date) {
    this.setState({ selectedDate: moment(date).format(DatePicker.sysDateFormat) });
  },
  handleDescriptionChange: function(e) {
    this.setState({ lossReasonDescription: e.target.value });
  },
  handleSave: function() {
    var lossDate = moment(this.state.selectedDate).format(DatePicker.sysDateFormat);
    var lossReasonId = this.state.selectedLossReasonId;
    var lossDescription = this.state.lossReasonDescription;

    var params = {
      "ends_at": lossDate,
      "deal_loss_reason": {
        "loss_reason_id": lossReasonId,
        "description": lossDescription
      },
      "deal_status": DEAL_STATUS_LOST_ID
    };

    if (this.state.dealLossReasonId) {
      params.deal_loss_reason.id = this.state.dealLossReasonId;
    }

    if (!lossReasonId) {
      params.deal_loss_reason._destroy = true;
    }

    dealsAPI.statusUpdate(this.props.dealId,
      params,
      this.handleAfterSave,
      this.handleRequestError);
  },
  handleAfterSave: function() {
    var lossReason = this.getSelectedLossReason(this.state.lossReasons);
    var lossDate = moment(this.state.selectedDate).format("YYYY-MM-DD 00:00:00");
    var lossDescription = this.state.lossReasonDescription;

    var selectedValues = {
      lossReason: lossReason,
      lossDate: lossDate,
      lossDescription: lossDescription
    };

    if (this.props.afterSaveCallback) {
      this.props.afterSaveCallback(selectedValues);
    }
  },
  getSelectedLossReason: function(lossReasons) {
    return _.find(lossReasons, {id: this.state.selectedLossReasonId});
  },
  onPopboxClose: function() {
    this.setState({ isPopboxVisible: false });

    if (this.props.onClose) {
      this.props.onClose();
    }
  },
  render: function() {
    return (
      <DealLostPopbox
        lossReasons={this.state.lossReasons}
        selectedLossReasonId={this.state.selectedLossReasonId}
        onSelectLossReason={this.handleSelectLossReason}
        onSave={this.handleSave}
        selectedDate={this.state.selectedDate}
        onDateChange={this.handleDateChange}
        lossReasonDescription={this.state.lossReasonDescription}
        onDescriptionChange={this.handleDescriptionChange}
        anchor={this.props.anchor}
        onClose={this.onPopboxClose}
        isVisible={this.state.isPopboxVisible} />
    );
  }
});

module.exports = DealLostPopboxContainer;



// WEBPACK FOOTER //
// ./app/shared/components/DealLostPopbox/deal-lost-popbox-container.jsx